import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useEmailLog } from '../../hooks/useAdmin';
import { formatDate } from './adminUtils';

export default function AdminEmailLog() {
    const [page, setPage] = useState(1);
    const [dateFrom, setDateFrom] = useState(new Date(Date.now() - 3 * 86400000).toISOString().slice(0, 10));
    const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));
    const { data, isLoading } = useEmailLog({ page, per_page: 20, date_from: dateFrom || undefined, date_to: dateTo || undefined });

    const items = data?.items ?? [];
    const totalPages = data?.pages ?? 1;

    return (
        <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, py: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#2c3e50', mb: 2 }}>
                Email log
            </Typography>

            <Paper sx={{ p: 2, mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                <TextField
                    label="Od"
                    type="date"
                    size="small"
                    value={dateFrom}
                    onChange={(e) => { setDateFrom(e.target.value); setPage(1); }}
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="Do"
                    type="date"
                    size="small"
                    value={dateTo}
                    onChange={(e) => { setDateTo(e.target.value); setPage(1); }}
                    InputLabelProps={{ shrink: true }}
                />
                {(dateFrom || dateTo) && (
                    <Button size="small" onClick={() => { setDateFrom(''); setDateTo(''); setPage(1); }}>
                        Očisti
                    </Button>
                )}
                <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
                    Ukupno: {data?.total ?? '—'}
                </Typography>
            </Paper>

            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
            ) : (
                <Paper sx={{ overflow: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 600 }}>Vrijeme</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Predmet</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Primatelji</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" sx={{ color: '#999', py: 3 }}>
                                        Nema email zapisa za odabrani period.
                                    </TableCell>
                                </TableRow>
                            ) : items.map((r) => (
                                <TableRow key={r.id} hover>
                                    <TableCell sx={{ whiteSpace: 'nowrap', fontSize: 13 }}>{formatDate(r.timestamp)}</TableCell>
                                    <TableCell sx={{ fontSize: 13 }}>{r.subject}</TableCell>
                                    <TableCell sx={{ fontSize: 12, color: '#666' }}>
                                        {r.to_addresses && r.to_addresses.length > 0
                                            ? r.to_addresses.join(', ')
                                            : typeof r.recipients === 'number' ? `${r.recipients} primatelja` : r.recipients}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    {totalPages > 1 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, py: 2 }}>
                            <Button size="small" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prethodna</Button>
                            <Typography variant="body2" sx={{ alignSelf: 'center' }}>{page} / {totalPages}</Typography>
                            <Button size="small" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Sljedeća</Button>
                        </Box>
                    )}
                </Paper>
            )}
        </Box>
    );
}
